<div class="mx-lg p-6">
        <div class="p-6">
            <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">
                <div>
                    <app-search-customer
                            [disabled]="!isSalesOrderCreate"
                            (selectedCustomerId)="onFieldSelected('customerId', $event)"
                            [customerId]="salesOrder().customerId">
                    </app-search-customer>
                </div>

                <div>
                    <div class="flex">
                        <button id="dropdown-button"
                                (click)="toggleDropdown()"
                                [disabled]="isOrderDelivered"
                                [ngClass]="{'border-red-500': isPoNumberExists(), 'border-gray-300': !isPoNumberExists()}"
                                class="shrink-0  w-fit inline-flex items-center py-2 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-e-0 rounded-s-lg hover:bg-gray-200 focus:outline-none focus:ring-0"
                                type="button">
                            {{ currentPoType() }}
                            <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2" d="m1 1 4 4 4-4"/>
                            </svg>
                        </button>
                        @if (isDropdownOpen()) {
                            <div class="z-30 absolute bg-white divide-y divide-gray-100 rounded-xl shadow-sm mt-10">
                                <ul class="py-2 text-sm text-gray-700" aria-labelledby="dropdown-button">
                                    <li><a (click)="setPoType('BULK-PO')"
                                           class="block px-4 py-2 hover:bg-gray-100 cursor-pointer">BULK-PO </a></li>
                                    <li><a (click)="setPoType('NO-PO')"
                                           class="block px-4 py-2 hover:bg-gray-100 cursor-pointer">NO-PO</a></li>
                                    <li><a (click)="setPoType('FOC')"
                                           class="block px-4 py-2 hover:bg-gray-100 cursor-pointer">FOC</a></li>
                                </ul>
                            </div>
                        }
                        <div class="relative w-full">
                            <input type="text"
                                   id="po-number"
                                   [disabled]="isOrderDelivered"
                                   autocomplete="off"
                                   [(ngModel)]="salesOrder().poNumber"
                                   (blur)="onPoNumberBlur()"
                                   (ngModelChange)="updateField('poNumber', $event)"
                                   (input)="enforcePrefix($event)"
                                   [ngClass]="{'border-red-500 focus:border-red-500': isPoNumberExists(), 'border-gray-300': !isPoNumberExists()}"
                                   class="block focus:ring-gray-100 focus:border-gray-300 p-2 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg "
                                   placeholder="Enter PO Number"
                                   required/>
                            @if (isValidatingPo()) {
                                <div class="absolute right-2 top-2">
                                    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="relative">
                    <input id="po-date"
                           type="date" class="peer w-full dateField" placeholder="PO Date"
                           [(ngModel)]="salesOrder().poDate"
                           autocomplete="off"
                           (ngModelChange)="updateField('poDate', $event)">
                    <label class="label" for="po-date">PO Date <span class="text-red-700">*</span></label>
                </div>

                <div class="relative">
                    <input type="number" id="poVal" class="textField peer" placeholder=" "
                           [(ngModel)]="salesOrder().poValue"
                           autocomplete="off"
                           positiveNumberOnly
                           (ngModelChange)="updateField('poValue', $event)"
                           name="poVal">
                    <label class="label" for="poVal">PO Value <span class="text-red-700">*</span></label>
                </div>

                <div>
                    <app-search-sales-executive 
                            [disabled]="!salesExecutiveStatus() && salesOrderService.active()?.salesOrderId"
                            [salesOwnerId]="salesOrder().salesExecutiveId"
                            (selectedSalesOwnerId)="onFieldSelected('salesExecutiveId', $event)"
                            (salesOwnerStatus)="handleSalesOwnerStatus($event)">
                    </app-search-sales-executive>
                </div>

                <div class="relative">
                    <input id="delivery-date"
                           type="date" class="peer w-full dateField" placeholder="Delivery Date"
                           [(ngModel)]="salesOrder().deliveryDate"
                           [min]="today | date:'yyyy-MM-dd'"
                           autocomplete="off"
                           (ngModelChange)="updateField('deliveryDate', $event)">
                    <label class="label" for="delivery-date">Delivery Date <span class="text-red-700">*</span></label>
                </div>

                <app-search-delivery
                        [addresses]="invoiceAddresses()"
                        [labelName]="'Invoice Address'"
                        [addressId]="salesOrder().invoiceAddressId"
                        (selectedAddress)="onFieldSelected('invoiceAddressId', $event)">
                </app-search-delivery>

                <app-search-delivery
                        [addresses]="deliveryAddresses()"
                        [labelName]="'Delivery Address'"
                        [addressId]="salesOrder().deliveryAddressId"
                        (selectedAddress)="onFieldSelected('deliveryAddressId', $event)">
                </app-search-delivery>

                <app-search-cro
                        [croId]="salesOrder().croId"
                        (selectedCRO)="onFieldSelected('croId', $event)">
                </app-search-cro>

                <div class="relative">
                    <input type="text" id="merch" class="textField peer" placeholder=" "
                           [(ngModel)]="salesOrder().merchandiser"
                           (ngModelChange)="updateField('merchandiser', $event)"
                           name="merch">
                    <label class="label" for="merch">Merchandiser <span class="text-red-700">*</span></label>
                </div>

                <app-search-currency 
                        [disabled]="Number(this.salesOrderService.active()?.salesOrderItemCount) != 0"
                        [currencyInput]="salesOrder().currencyId"
                        (selectCurrency)="onFieldSelected('currencyId', $event)">
                </app-search-currency>

                <div class="relative">
                    <input id="poReceivedDate"
                           type="datetime-local" class="peer w-full dateField" placeholder="PO Received Date"
                           [(ngModel)]="salesOrder().poReceivedDate"
                           [disabled]="Number(this.salesOrderService.active()?.salesOrderItemCount) != 0"
                           [autocomplete]="false"
                           (ngModelChange)="updateField('poReceivedDate', $event)">
                    <label class="label" for="poReceivedDate">PO Received Date <span class="text-red-700">*</span></label>
                </div>
                
            </div>

            @if (!isSalesOrderCreate) {
                <div class="flex py-4 border-b"></div>
            }

            <div class="flex justify-end space-x-3 mt-6">
                @if (isSalesOrderCreate) {
                    <button (click)="cancel()"
                            class="button-white">
                        Clear
                    </button>
                } 
                <button
                        (mouseenter)="onDisabledButtonHover()"
                        (click)="createSalesOrder()"
                        [disabled]="isValidCreation()"
                        class="button-blue">
                    {{ salesOrderService.active() ? 'Update' : 'Create' }}
                </button>
            </div>
        </div>
</div>